"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const galleryItems = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.37.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.37.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.37.jpg-wvc-sizes",
  alt: "Corporate Strategy Workshop",
  title: "Corporate Strategy",
  description: "Comprehensive workshops designed to align leadership teams and drive organizational growth."
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.26.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.26.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.26.jpg-wvc-sizes",
  alt: "Team Building & Collaboration",
  title: "Team Synergy",
  description: "Interactive sessions focused on improving communication, trust, and collaborative problem-solving."
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.27.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.27.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.27.jpg-wvc-sizes",
  alt: "Technical Skills Bootcamp",
  title: "Technical Mastery",
  description: "Intensive bootcamps equipping professionals with the latest industry-standard technical skills."
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.34.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.34.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.34.jpg-wvc-sizes",
  alt: "Communication & Public Speaking",
  title: "Executive Communication",
  description: "Master the art of persuasive speaking and effective interpersonal communication in business."
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.35.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.35.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/WhatsApp Image 2026-06-05 at 21.50.35.jpg-wvc-sizes",
  alt: "Project Management Essentials",
  title: "Agile Project Management",
  description: "Learn modern methodologies to deliver projects on time, within budget, and beyond expectations."
}];
export default function ImageGalleryGrid() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="image-gallery-grid" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`mb-12 text-center transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-4">
            Professional Training Programs
          </h2>
          <p className="font-sans text-muted-foreground max-w-2xl mx-auto text-lg">
            Explore our comprehensive range of professional development courses designed to elevate your team's performance and drive success.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 transition-all duration-1000 ease-out delay-100 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {galleryItems.map((item, i) => <Card key={item.id} data-index={i} className="group overflow-hidden border-border/40 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col bg-card">
              <div className="overflow-hidden bg-muted">
                <AspectRatio ratio={16 / 10}>
                  <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" />
                </AspectRatio>
              </div>
              <CardHeader className="flex-grow pt-6">
                <CardTitle className="font-default text-xl text-card-foreground">
                  {item.title}
                </CardTitle>
                <CardDescription className="font-sans text-base mt-2 text-muted-foreground">
                  {item.description}
                </CardDescription>
              </CardHeader>
            </Card>)}
        </div>
      </div>
    </section>;
}